import { h } from "preact";

const GiftIcon = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="52" fill="none">
      <circle cx="15.1" cy="13.8" r="13.8" fill={props.color} />
      <g stroke="#000" stroke-linecap="round" stroke-linejoin="round">
        <path d="M11.364 29.613c1.93 0 3.906-.241 5.785-.665 3.417-.77 7.991-2.372 9.873-5.748 2.41-4.325 2.335-10.571.712-15.22-.737-2.11-2.171-3.847-4.108-4.852-1.986-1.03-4.454-.665-6.609-.665-5.536 0-10.168 2.065-13.035 7.13C1.542 13.905.347 19.139 2.213 23.98c.559 1.45 2.158 3.253 3.498 3.987.346.19 1.668.733 1.627.781-.608.705-1.049 1.684-1.606 2.447-.911 1.247-2.175 1.827-3.518 2.405 1.295.402 4.486.844 6.886-.6" />
        <path d="M33.104 36c-.876-.356-1.7-.713-2.294-1.48-.363-.469-.651-1.072-1.048-1.506-.027-.029.835-.364 1.061-.48.874-.452 1.916-1.561 2.281-2.454 1.218-2.979.438-6.2-1.154-8.854-1.87-3.117-4.891-4.388-8.501-4.388-1.405 0-3.015-.225-4.31.409-1.263.618-2.198 1.687-2.679 2.986-1.058 2.861-1.108 6.705.464 9.367 1.227 2.078 4.21 3.063 6.439 3.538 1.225.261 2.514.409 3.773.409" />
      </g>
    </svg>
  );
};

export default GiftIcon;
